/* global axios */
import ApiClient from './ApiClient';

class AiNetworkOutages extends ApiClient {
  constructor() {
    super('ai/network_outages', { accountScoped: true });
  }

  // A conta vem por parâmetro (a tabela recebe `accountId` por prop e é dona do
  // próprio fetch) — sem depender do path da rota estar montado. Cai no `url`
  // do ApiClient quando nenhuma é passada.
  scopedUrl(accountId) {
    return accountId
      ? `${this.apiVersion}/accounts/${accountId}/${this.resource}`
      : this.url;
  }

  // GET /ai/network_outages?status=&page=&per_page=&sort=&order=&q=&system_label=
  // → { payload: [outage], meta: { total_count, current_page, per_page } }
  //
  // Ciclo de vida já persistido (Postgres puro) — responde em ms, usa o timeout
  // default do app. NÃO é o compute ao vivo do `aiMassiva` (10-45s no ERP).
  // `signal` (AbortController) descarta resposta obsoleta quando o usuário troca
  // ordenação/página/busca antes da anterior voltar.
  list(
    accountId,
    { status, page, perPage, sort, order, q, systemLabel } = {},
    { signal } = {}
  ) {
    return axios.get(this.scopedUrl(accountId), {
      // systemLabel vazio (sem filtro de instância) não vira query param
      params: {
        status,
        page,
        per_page: perPage,
        sort,
        order,
        q,
        system_label: systemLabel || undefined,
      },
      signal,
    });
  }

  // GET /ai/network_outages/:id/clients → { payload: [client] }
  // Clientes afetados da caixa — carregado só quando a linha expande.
  clients(accountId, id, { signal } = {}) {
    return axios.get(`${this.scopedUrl(accountId)}/${id}/clients`, { signal });
  }
}

export default new AiNetworkOutages();
